import type { MessageKey } from "./en";

export const pt: Record<MessageKey, string> = {
  "tabs.transfer": "Venda",
  "tabs.convert": "Converter pontos",
  "tabs.history": "Histórico",

  "convert.pointsAvailable": "Pontos da agência",
  "convert.coinsStock": "Coins Trading",
  "convert.rateTitle": "Taxa de conversão",
  "convert.rateLine": "{points} pontos = {coins} moedas",
  "convert.ratePerCoin": "1 moeda = {perCoin} pontos",
  "convert.amountLabel": "* Moedas a receber",
  "convert.amountPlaceholder": "Digite a quantidade de moedas",
  "convert.max": "Máx.",
  "convert.cost": "Você vai gastar {points} pontos",
  "convert.limits": "Mínimo {min} moedas · máximo agora {max} moedas",
  "convert.packagesLabel": "* Escolha um pacote",
  "convert.packageLine": "{points} pontos → {coins} moedas",
  "convert.packageNotEnough": "Pontos insuficientes",
  "convert.packagesHint": "Conversão só em pacotes prontos (mínimo {min} moedas).",
  "convert.error.invalid_package": "Escolha um dos pacotes prontos.",
  "convert.button": "Converter",
  "convert.sending": "Convertendo...",
  "convert.confirmTitle": "Confirmar conversão",
  "convert.confirmCoins": "Você recebe",
  "convert.confirmPoints": "Você gasta",
  "convert.confirmRate": "Taxa",
  "convert.confirmPointsAfter": "Pontos depois",
  "convert.confirmCoinsAfter": "Coins Trading depois",
  "convert.coinsUnit": "{value} moedas",
  "convert.pointsUnit": "{value} pontos",
  "convert.cancel": "Cancelar",
  "convert.confirm": "Confirmar",
  "convert.success": "Convertido: {points} pontos → {coins} moedas no seu Coins Trading.",
  "convert.loading": "Carregando seu saldo...",

  "convert.error.below_minimum": "A conversão mínima é de {min} moedas.",
  "convert.error.invalid_coins": "Informe um número inteiro de moedas, maior que zero.",
  "convert.error.not_enough_points": "Pontos da agência insuficientes para esse valor. Nada foi alterado.",
  "convert.error.agency_not_found": "Esta conta não é dona de uma agência revendedora.",
  "convert.error.conversion_rate_unavailable": "A taxa de conversão não está disponível agora. Fale com o suporte.",
  "convert.error.invalid_token": "Sua sessão expirou. Entre novamente.",
  "convert.error.user_moderation_cannot_use_monetization": "Sua conta não pode converter agora.",
  "convert.error.generic": "Não foi possível converter. Nada foi alterado — verifique sua conexão e tente de novo.",

  "history.summary.title": "Total desta lista",
  "history.summary.line": "{coins} moedas vendidas · {count} vendas",
  "history.summary.reversedLine": "Estornadas (não contam): {coins} moedas · {count} vendas",
  "history.summary.loading": "Calculando o total...",
  "history.filter.all": "Todas as vendas",
  "history.filter.user": "ID do comprador {id}",
  "history.filter.from": "de {date}",
  "history.filter.to": "até {date}",
  "history.download.xlsx": "Excel (.xlsx)",
  "history.download.pdf": "PDF",
  "history.download.working": "Gerando o arquivo...",
  "history.download.done": "Arquivo baixado: {count} vendas.",
  "history.download.error": "Não foi possível gerar o arquivo. Tente de novo.",
  "history.export.title": "Histórico de vendas",
  "history.export.filter": "Filtro",
  "history.export.truncated": "Este arquivo traz só as {limit} vendas mais recentes.",
  "history.export.colDate": "Data",
  "history.export.colSaleId": "Venda",
  "history.export.colBuyerId": "ID do comprador",
  "history.export.colBuyerName": "Nome do comprador",
  "history.export.colType": "Tipo",
  "history.export.colCoins": "Moedas",
  "history.export.colValue": "Valor (R$)",
  "history.export.period": "Período",
  "history.export.priceLine": "Valor a R$ 1 = {coins} moedas",
  "history.export.generatedAt": "Gerado em {date}",
  "history.export.sheetName": "Vendas",
  "history.export.totalsLabel": "TOTAL (vendidas)",
  "history.export.totalsHint": "Estornadas não entram",
  "history.export.salesUnit": "vendas",
  "history.summary.salesCount": "{count} vendas",
  "history.summary.valueLine": "≈ {value}",
  "history.list.totalsTitle": "Total do filtro",
  "history.kind.sale": "Venda",
  "history.kind.reversal": "Estorno",
  "history.kind.conversion": "Conversão",
  "history.kind.other": "Outro movimento",
  "history.kind.unrecorded": "Mudança sem registro",
  "history.export.colCoinsSold": "Moedas vendidas",
  "history.export.colMovement": "Movimento do estoque",
  "history.export.colPoints": "Pontos gastos",
  "history.export.colBalance": "Saldo depois",
  "history.export.statusReversalOf": "Venda #{id} estornada (moedas voltaram ao estoque)",
  "history.export.statusConversion": "{points} pontos convertidos",
  "history.export.statusUnrecorded": "Estoque mudou sem registro no ledger (ex.: conversão feita em outro lugar)",
  "history.export.opening": "Saldo inicial (Coins Trading)",
  "history.export.closing": "Saldo final (Coins Trading)",
  "history.export.totalsSales": "VENDAS (vendidas)",
  "history.export.totalsConversions": "CONVERSÕES",
  "history.export.totalsMovement": "TODOS OS MOVIMENTOS",
  "history.export.check": "CONFERÊNCIA (inicial + movimentos − final)",
  "history.export.checkLine": "{opening} {movement} = {closing}",
  "history.summary.conversionsCount": "{count} conversões",
  "history.summary.conversionsLine": "Convertido: {coins} moedas · {count} conversões",
  "history.summary.balanceLine": "Coins Trading: {opening} → {closing}",
  "history.row.conversion": "+{coins} moedas · −{points} pontos",
  "history.row.reversalOf": "Venda #{id} estornada",
  "history.row.balance": "Saldo {value}",
  "history.row.unrecorded": "Estoque mudou sem registro",
  "history.export.colStatus": "Situação",
  "history.export.typeUser": "Usuário",
  "history.export.typeAgent": "Agente",
  "history.export.statusSold": "Vendida",
  "history.export.statusReversed": "Estornada em {date}",
};
